import styled from 'styled-components';

export const FleetManagementHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem 0.5rem;
`;

export const FiltersContainer = styled.div`
  display: grid;
  grid-template-columns:
    minmax(200px, 1.1fr)
    minmax(200px, 1.1fr)
    minmax(200px, 1fr)
    minmax(200px, 1fr)
    minmax(170px, 0.9fr)
    minmax(170px, 0.9fr)
    auto
    auto;
  gap: 12px;
  align-items: end;

  @media (max-width: 1600px) {
    grid-template-columns:
      repeat(4, minmax(200px, 1fr))
      minmax(170px, 0.9fr)
      minmax(170px, 0.9fr)
      auto
      auto;
  }

  @media (max-width: 1280px) {
    grid-template-columns: repeat(2, minmax(200px, 1fr));
  }
`;

export const SecondHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 4px;
  & > div {
    display: flex;
    gap: 4px;
    flex-shrink: 0;
  }
`;
